import type { SortDirection } from "@digits-graphql/frontend/graphql-bearer"
import type { PreferenceValueMap } from "src/shared/config/preferenceDefinitions"
import { buildPreferenceKeys, definePreference } from "src/shared/config/preferenceDefinitions"

type FirmDashboardClientTableSort = {
  field: string
  direction: SortDirection
}

export const userPreferenceDefinitions = {
  expandedView: definePreference<boolean>()({
    key: "expanded-view",
    kind: "boolean",
  }),
  editLedger: definePreference<boolean>()({
    key: "edit-ledger",
    kind: "boolean",
  }),
  editProductCatalog: definePreference<boolean>()({
    key: "edit-product-catalog",
    kind: "boolean",
  }),
  editDiscountCatalog: definePreference<boolean>()({
    key: "edit-discount-catalog",
    kind: "boolean",
  }),
  vaultListView: definePreference<boolean>()({
    key: "vault-list-view",
    kind: "boolean",
    defaultValue: true,
  }),
  firmDashboardListView: definePreference<boolean>()({
    key: "firm-dashboard.list-view",
    kind: "boolean",
    defaultValue: true,
  }),
  firmDashboardClientTableSort: definePreference<FirmDashboardClientTableSort | undefined>()({
    key: "firm-dashboard.client-table-sort",
    kind: "json",
  }),
  allClientsPreferredFirmId: definePreference<string | undefined>()({
    key: "all-clients.preferred-firm-id",
    kind: "string",
  }),
  viewedAssistant: definePreference<boolean>()({
    key: "viewed-assistant",
    kind: "boolean",
  }),
  agentBar: definePreference<{ view: "default" | "collapsed" } | undefined>()({
    key: "agent-bar",
    kind: "json",
  }),
  transactionDimensionColumn: definePreference<string | undefined>()({
    key: "transaction-dimension-column",
    kind: "string",
  }),
  ledgerCategoryPanelWidth: definePreference<number | undefined>()({
    key: "ledger-category-panel-width",
    kind: "number",
  }),
  sidePanelCollapsed: definePreference<boolean>()({
    key: "side-panel-collapsed",
    kind: "boolean",
    defaultValue: false,
  }),
  orgDashboardPreferredOrgId: definePreference<string | undefined>()({
    key: "org-dashboard.preferred-org-id",
    kind: "string",
  }),
  timezoneOverride: definePreference<string | undefined>()({
    key: "timezone-override",
    kind: "string",
  }),
} as const

export const userPreferenceKeys = buildPreferenceKeys(userPreferenceDefinitions)

export type UserPreferenceValueMap = PreferenceValueMap<typeof userPreferenceDefinitions>
